import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const createScheduleSchema = (ids) =>
  yup.object(
    Object.fromEntries(
      ids.flatMap((id) => [
        [
          `startTime_${id}`,
          yup
            .string()
            .nullable()
            .when(`supports24_${id}`, {
              is: false,
              then: yup.string().required("Start time is required"),
              otherwise: yup.string().nullable(),
            }),
        ],
        [
          `endTime_${id}`,
          yup
            .string()
            .nullable()
            .when(`supports24_${id}`, {
              is: false,
              then: yup
                .string()
                .required("End time is required")
                .test(
                  "is-greater",
                  "End time must be later than start time",
                  function (value) {
                    const start = this.parent[`startTime_${id}`];
                    return start && value ? value > start : true;
                  },
                ),
              otherwise: yup.string().nullable(),
            }),
        ],
        [`supports24_${id}`, yup.boolean().required()],
      ]),
    ),
  );

const useScheduleValidation = ({ scheduleData }) => {
  const ids = scheduleData.map((item) => item.id);
  const schema = createScheduleSchema(ids);

  return useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: Object.fromEntries(
      scheduleData.flatMap((item) => [
        [`startTime_${item.id}`, item.delivery_start_time || ""],
        [`endTime_${item.id}`, item.delivery_end_time || ""],
        [`supports24_${item.id}`, item.supports_24_hours_delivery ?? false],
      ]),
    ),
  });
};

export default useScheduleValidation;
